#import "./list/TravelSectionAuthDataFragment.graphql"
fragment TravelAuthorizationListFields on TravelAuthorization {
  __typename
  id
  _urgencyLevel
  _isOverBudget
  _travelerReference
  _rowTimestamp
  _isUpdatable
  _isDeletable
  _createdDate
  _createdByUserName
  travelAuthorizationNumber
  _poStatus
  comment
  _isCorporateTravelAuthorization
  _suppliers
  corporateWorkgroupName
  tripPurpose
  travelAuthorizationDate
  department {
    name
  }
  businessUnit {
    name
  }
  currency {
    isoCode
    name
    currencySymbol
  }
  budgetAmount
  controlTotalAmount
  statusType {
    statusType
    approvalState
    _transactionIconStatus
  }
  _pendingApprovers
  _isStagedApprovalRequest
  _isApprovalRevocable
  ...TravelAuthorizationTravelSectionFragment
  _isAccountingEntryStampedComplete
  _isStampAllowed
  _isAccountingEntry
  _accountingStampTransactionReference
}
